import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

// log actions
export const actions = prepActions(service);

// log sagas
export const productLogSagas = createController(service, actions);
